{
  "back_to_home": "Zurück zur Startseite",
  "cabins": "Kabinen",
  "departure_date": "Abfahrtsdatum",
  "payment": "Zahlung",
  "personal_information": "Persönliche Daten",
  "price_overview": "Preisübersicht & Extras",
  "ship": "Schiff"
}
